import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

import logo from "../../images/logo-full.png";
import bgimage from "../../images/login-img/pic-5.jpg";
import { authenticate } from "../../feature/authSlice";
import EmailPhoneCombine from "../../jsx/components/fields/emailPhoneField";
import PasswordField from "../../jsx/components/fields/passwordField";
import PrimaryButton from "../../jsx/components/button/primaryButton";
import outerPhoto from "../../icons/photos/loginPagePhoto.png";
import { requestForToken } from "../../firebase";
import "./auth.scss";
import {
  confirmPasswordValidation,
  emailValidation,
  noSpaceOnChange,
  passwordValidation,
  phoneValidation,
} from "../../validations/validation";
import { setUserDetails } from "../../feature/userData/userData";
import { checkCredentials } from "../../service/api/user/login";
import InputField from "../../jsx/components/fields/inputField";
import { resetPassword } from "../../service/api/user/resetPassword";
import ResponceToaster from "../../jsx/components/responceToaster/responceToaster";

export default function ResetPassword(props) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [password, setPassword] = useState("");

  const [isNewPassword, setIsNewPassword] = useState(false);
  const [isConfirmPassword, setIsConfirmPassword] = useState(false);
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  const [loaderActive, setLoaderActive] = useState(false);

  const [loading, setLoading] = useState(false);

  const [responceMsg, setResponceMsg] = useState("");
  const [toasterType, setToasterType] = useState();
  const [handleToaster, setHandleToaster] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    if (passwordValidation(newPassword)) {
      if (confirmPasswordValidation(newPassword, confirmPassword)) {
        let details = {
          phone_code_id_int: parseInt(localStorage.getItem("get_countryCode")),
          phone_number_int: parseInt(localStorage.getItem("get_phonenumber")),
          email_chr: localStorage.getItem("get_email"),
          new_password: newPassword,
          confirm_password: confirmPassword,
          security_code_chr: localStorage.getItem("securityCode"),
        };
        dispatch(
          resetPassword(
            details,
            (res) => {
              setLoading(false);
              setResponceMsg(res.data.message);
              setToasterType("success");
              setNewPassword("");
              setConfirmPassword("");
              setHandleToaster(true);
              setTimeout(() => {
                setHandleToaster(false);
                navigate("/");
              }, 1000);
            },
            (error) => {
              setLoading(false);
              setResponceMsg(error.data.message);
              setToasterType("error");

              setHandleToaster(true);
              setTimeout(() => {
                setHandleToaster(false);
              }, 1000);
            }
          )
        );
      } else {
        setIsConfirmPassword(true);
      }
    } else {
      setIsNewPassword(true);
      setLoading(false);
    }
  };

  const handleNewPassword = (e) => {
    setIsNewPassword(false);
    setNewPassword(e.target.value);
  };
  const handleConfirmPassword = (e) => {
    setIsConfirmPassword(false);
    setConfirmPassword(e.target.value);
  };

  function handleNewPasswordBlur() {
    if (!passwordValidation(newPassword)) {
      setIsNewPassword(true);
    }
  }

  function handleConfirmPasswordBlur() {
    if (!confirmPasswordValidation(newPassword, confirmPassword)) {
      setIsConfirmPassword(true);
    }
  }
  function handleMoveToSignUp() {
    navigate("/signup", { replace: true });
  }

  return (
    <div className="">
      <div className="row  align-items-center justify-contain-center bg-login">
        <div className="col-xl-12 ">
          <div className="card border-0">
            <div className="card-body login-bx">
              <div className="row ">
                <div className="col-xl-7 col-md-6  text-center">
                  <img src={outerPhoto} alt="" style={{ maxWidth: "100%" }} />
                </div>
                <div
                  className="col-xl-4 col-md-6 pe-0 d-flex"
                  style={{ alignItems: "center" }}>
                  <div className="sign-in-your">
                    <div>
                      <p
                        className="login-title"
                        style={{ fontSize: "21px", fontWeight: "600" }}>
                        Create New Password
                      </p>
                    </div>

                    <form onSubmit={handleSubmit}>
                      <PasswordField
                        onChange={handleNewPassword}
                        inputValue={newPassword}
                        errorOccured={isNewPassword}
                        errorMessage={"invalid password"}
                        labelName={"Password"}
                        handleOnBlur={handleNewPasswordBlur}
                      />
                      <PasswordField
                        onChange={handleConfirmPassword}
                        inputValue={confirmPassword}
                        errorOccured={isConfirmPassword}
                        errorMessage={"Password doesnot match"}
                        labelName={"Confirm Password"}
                        handleOnBlur={handleConfirmPasswordBlur}
                      />

                      <div>
                        <p>
                          Do not have account yet?{" "}
                          <span
                            className="waiting-txt"
                            onClick={handleMoveToSignUp}>
                            Register here
                          </span>
                        </p>
                      </div>
                      <PrimaryButton
                        buttonName={"Submit"}
                        type={"submit"}
                        isLoading={loading}
                        loadingMessage={"Loading..."}
                      />
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {handleToaster && (
        <ResponceToaster toasterType={toasterType} message={responceMsg} />
      )}
    </div>
  );
}
